export const HYDRATION_READY_EVENT = "finda:hydrated";

// Preserve the first button tap while its server-rendered UI is hydrating.
// Links retain their normal browser navigation throughout loading.
export const DEFERRED_INTERACTIONS_SCRIPT = `(() => {
  const pending = new WeakMap();
  window.addEventListener('click', event => {
    const button = event.target.closest?.('button');
    const scope = button?.closest('[data-hydration-pending]');
    if (!scope || button.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!pending.has(scope)) pending.set(scope, button);
  }, true);
  window.addEventListener(${JSON.stringify(HYDRATION_READY_EVENT)}, event => {
    const button = pending.get(event.target);
    pending.delete(event.target);
    if (button) queueMicrotask(() => { if (button.isConnected) button.click(); });
  });
})();`;
